<template>
  <BaseCRUDPageLayout :links="links">
    <template v-slot:tableName> إضافة مشرف جديد </template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <CreateAdminForm />
        </v-col>
      </v-row>
    </v-container>
  </BaseCRUDPageLayout>
</template>

<script>
import CreateAdminForm from "../components/forms/CreateAdminForm.vue";

export default {
  data() {
    return {
      links: [
        {
          text: "الصفحة الرئيسية",
          href: "/",
          disabled: false,
        },
        {
          text: "مشرفي المنصة",
          href: "/admins",
          disabled: false,
        },
        {
          text: " إضافة مشرف جديد",
          disabled: true,
        },
      ],
    };
  },
  components: { CreateAdminForm },
};
</script>
